import { ReactComponent as NewsSVG } from "./news.svg";
import { SvgIcon } from '@mui/material';

export default function IconNews(props) {
  return <SvgIcon {...props} component={NewsSVG} viewBox="0 0 25 24" />;
}